var _defs, _rect, _rect2, _text, _path, _text2, _path2, _text3, _rect3, _rect4, _rect5, _rect6, _text4, _circle, _path3, _path4, _rect7, _rect8, _path5, _text5, _path6, _path7, _rect9, _rect10, _rect11, _rect12, _text6, _circle2, _path8, _path9, _rect13, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _text7, _path17, _text8, _path18, _text9, _text10, _text11, _text12, _text13, _rect14, _rect15, _text14, _rect16, _path19, _path20, _path21, _path22, _path23, _path24, _rect17, _rect18, _text15, _rect19, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _rect20, _path39, _text16, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _text17, _path51, _text18, _path52, _text19, _path53, _text20, _text21, _rect21, _text22, _path54, _path55, _path56, _path57, _path58, _text23, _path59, _text24, _path60, _text25, _path61, _text26, _path62, _text27, _path63, _text28, _path64, _text29, _path65, _rect22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIstioSecurityarch = function SvgIstioSecurityarch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "istio-securityarch_svg__a9410d12-0d61-4860-9caf-4aa81d73d3ab",
    "data-name": "Layer 1",
    viewBox: "0 0 1127.8 536.22"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".istio-securityarch_svg__b75fe515-d9ce-447c-aff3-ab473cb81ba9,.istio-securityarch_svg__f5b41e30-30ae-4f26-b089-04ac86fe57e2{fill:#466bb0}.istio-securityarch_svg__b75fe515-d9ce-447c-aff3-ab473cb81ba9,.istio-securityarch_svg__b9c830ba-5174-4bc5-8188-f1ace757097b{opacity:.1}.istio-securityarch_svg__a6b88054-fdd2-41fb-8800-4aaaac89010e,.istio-securityarch_svg__b08a60e8-d5e3-47c6-8765-54e91386a2e2,.istio-securityarch_svg__b7126ed3-0723-4d7f-8489-44e9140a611e,.istio-securityarch_svg__bd05d7e9-dff2-42d4-80e0-8544a2be094c,.istio-securityarch_svg__e490bdda-b499-42e6-a54a-e78f2b8aa3b2,.istio-securityarch_svg__fbf59e5c-7545-4d21-8f09-14871b9280fe{fill:none}.istio-securityarch_svg__bd05d7e9-dff2-42d4-80e0-8544a2be094c{stroke:#466bb0;stroke-dasharray:10.03 10.03}.istio-securityarch_svg__b08a60e8-d5e3-47c6-8765-54e91386a2e2,.istio-securityarch_svg__b7126ed3-0723-4d7f-8489-44e9140a611e,.istio-securityarch_svg__bd05d7e9-dff2-42d4-80e0-8544a2be094c,.istio-securityarch_svg__fbf59e5c-7545-4d21-8f09-14871b9280fe{stroke-linejoin:round}.istio-securityarch_svg__a8abd049-976e-4fc1-ae51-c49f9aa3fee7,.istio-securityarch_svg__afd526ee-25e6-459f-8c03-25ae8d4a7803,.istio-securityarch_svg__ea96df71-f7e5-489f-a491-48f7b5240008{font-size:12px}.istio-securityarch_svg__a398c1c0-1ae6-42aa-bd8e-928a7dc6a7af,.istio-securityarch_svg__a8abd049-976e-4fc1-ae51-c49f9aa3fee7,.istio-securityarch_svg__a8cc6f2d-c1e4-4508-b7b0-186499b7717d,.istio-securityarch_svg__afd526ee-25e6-459f-8c03-25ae8d4a7803,.istio-securityarch_svg__bb4f2cbc-d575-4a0d-84f1-538b3757378c,.istio-securityarch_svg__e1911d25-aca7-4ebb-a506-9b48914bf416,.istio-securityarch_svg__f710b24f-5a6e-46e9-b971-052267f34d76{fill:#010101}.istio-securityarch_svg__afd526ee-25e6-459f-8c03-25ae8d4a7803{font-family:GoogleSansDisplay-Bold,Google Sans Display;font-weight:700}.istio-securityarch_svg__ab2bf7fd-baf8-4581-9478-25c8e49617f0{letter-spacing:-.01em}.istio-securityarch_svg__a268483b-21e1-4920-849e-de9919c4d825{letter-spacing:.01em}.istio-securityarch_svg__b61332c7-925b-4261-8548-1c7de017d7fe{letter-spacing:0}.istio-securityarch_svg__ea92d7dd-0be3-4413-8853-ed38e711a5c4{letter-spacing:-.01em}.istio-securityarch_svg__e3388f18-8853-483b-adb1-110dc806dcf3{letter-spacing:0}.istio-securityarch_svg__f1b48762-a0d4-422b-9317-38c92e67aea4{fill:#119a48}.istio-securityarch_svg__a8cc6f2d-c1e4-4508-b7b0-186499b7717d{font-size:10px}.istio-securityarch_svg__a398c1c0-1ae6-42aa-bd8e-928a7dc6a7af,.istio-securityarch_svg__a8abd049-976e-4fc1-ae51-c49f9aa3fee7,.istio-securityarch_svg__a8cc6f2d-c1e4-4508-b7b0-186499b7717d,.istio-securityarch_svg__bb4f2cbc-d575-4a0d-84f1-538b3757378c,.istio-securityarch_svg__e1911d25-aca7-4ebb-a506-9b48914bf416,.istio-securityarch_svg__ea96df71-f7e5-489f-a491-48f7b5240008,.istio-securityarch_svg__f710b24f-5a6e-46e9-b971-052267f34d76{font-family:GoogleSansDisplay-Regular,Google Sans Display}.istio-securityarch_svg__b47a11b2-bdd4-4c94-a536-3ff3890aae6b{letter-spacing:-.04em}.istio-securityarch_svg__a6ab78ef-dc09-439b-b29c-a69373a26726{letter-spacing:-.03em}.istio-securityarch_svg__a3f38e67-06e9-418e-964a-eba38bee4535,.istio-securityarch_svg__f911231f-cd5e-4ff1-9d21-8aa3b7be3411{fill:#e5e5e4}.istio-securityarch_svg__b555c1bb-b960-46c7-8767-d80146dadbf4{fill:#777678}.istio-securityarch_svg__e9bb5c86-6a6c-4e63-a35a-a8db12e9f576{fill:#fff}.istio-securityarch_svg__e1911d25-aca7-4ebb-a506-9b48914bf416,.istio-securityarch_svg__f710b24f-5a6e-46e9-b971-052267f34d76{font-size:14px}.istio-securityarch_svg__f215488f-4682-4fb8-bf55-00eb7742a09b{letter-spacing:.02em}.istio-securityarch_svg__a444e6db-ea27-4308-8d0c-46755eb75974,.istio-securityarch_svg__aff424b6-2386-4897-a8aa-c88604ade126{letter-spacing:0}.istio-securityarch_svg__b7126ed3-0723-4d7f-8489-44e9140a611e,.istio-securityarch_svg__e490bdda-b499-42e6-a54a-e78f2b8aa3b2{stroke:#fff}.istio-securityarch_svg__a6b88054-fdd2-41fb-8800-4aaaac89010e,.istio-securityarch_svg__b7126ed3-0723-4d7f-8489-44e9140a611e,.istio-securityarch_svg__e490bdda-b499-42e6-a54a-e78f2b8aa3b2{stroke-width:2px}.istio-securityarch_svg__e490bdda-b499-42e6-a54a-e78f2b8aa3b2,.istio-securityarch_svg__fbf59e5c-7545-4d21-8f09-14871b9280fe{stroke-linecap:round}.istio-securityarch_svg__a3f38e67-06e9-418e-964a-eba38bee4535,.istio-securityarch_svg__a6b88054-fdd2-41fb-8800-4aaaac89010e,.istio-securityarch_svg__e490bdda-b499-42e6-a54a-e78f2b8aa3b2{stroke-miterlimit:10}.istio-securityarch_svg__b08a60e8-d5e3-47c6-8765-54e91386a2e2{stroke:#b24d9d;stroke-width:3px}.istio-securityarch_svg__e0c131b3-1fb0-4364-99e1-d9ef61b24568{letter-spacing:-.03em}.istio-securityarch_svg__a2d57362-92c3-4fb5-ad27-66d8242cc870{letter-spacing:-.01em}.istio-securityarch_svg__aa256662-fce3-4dfa-8196-2ac4340fe192{fill:#f26722}.istio-securityarch_svg__a6b88054-fdd2-41fb-8800-4aaaac89010e{stroke:#07a14a}.istio-securityarch_svg__b3dd7e29-de12-474a-868d-77c247e13299{fill:#07a14a}.istio-securityarch_svg__bb4f2cbc-d575-4a0d-84f1-538b3757378c{font-size:7.08px;letter-spacing:-.03em}.istio-securityarch_svg__fe02ae3a-15e1-46f2-8238-f497270e65c3{letter-spacing:0}.istio-securityarch_svg__a810eeb5-5a15-4495-9be4-710ca0482784{letter-spacing:-.02em}.istio-securityarch_svg__e664c73c-edca-4ee3-8fe2-53e19520945e{letter-spacing:-.01em}.istio-securityarch_svg__be90388b-953c-4ed6-ad3e-620ab818c306{letter-spacing:-.02em}.istio-securityarch_svg__b74a8556-9fc9-4542-86da-8e2f8a352bc5{letter-spacing:0}.istio-securityarch_svg__f294b4bc-f111-4b0c-b273-d813f8cd51c6{letter-spacing:.01em}.istio-securityarch_svg__a11a0377-9de2-4d2e-8295-e64eabcec3bc,.istio-securityarch_svg__b9f4022a-cb44-4b28-9d49-2e44f3559bf8{letter-spacing:-.02em}.istio-securityarch_svg__e6480a8b-4b7e-4e1a-a2e5-f1e99d17a805{letter-spacing:0}.istio-securityarch_svg__e3ffed98-503d-45b3-b0c6-b7874c340aa6{letter-spacing:-.08em}.istio-securityarch_svg__b7667c73-2320-4c1d-85d4-96bd11145e54{letter-spacing:-.04em}.istio-securityarch_svg__b5415851-a9cf-4cd0-9014-873c46460b72{letter-spacing:-.03em}.istio-securityarch_svg__af6d43bc-00a4-4711-a1cb-95cd49d9a76c{letter-spacing:0}.istio-securityarch_svg__a4a8bb30-a42b-42b3-a70f-d7d928142f4a{letter-spacing:-.01em}.istio-securityarch_svg__f77554e1-c234-40bf-abe0-204ca99438d5{letter-spacing:0}.istio-securityarch_svg__b2116ce1-e6d1-4eee-9fa6-6cb9d29b3ff3{letter-spacing:-.03em}.istio-securityarch_svg__bcf7907a-0a3a-46f6-b6ba-66a19443026c{letter-spacing:0}.istio-securityarch_svg__fb5ff91e-8f6c-4919-a823-bd6b85396607{fill:#486baf}.istio-securityarch_svg__f1c88488-b5ef-4a20-b5d1-08319cc6fd65{letter-spacing:-.01em}.istio-securityarch_svg__eda56b98-ff2a-4819-971e-c6ea8d36d0f7{letter-spacing:-.03em}.istio-securityarch_svg__fbf59e5c-7545-4d21-8f09-14871b9280fe{stroke:#486baf;stroke-width:4px;stroke-dasharray:6 12}.istio-securityarch_svg__e63f4eeb-de41-4515-91a9-a2e2c10abae1{letter-spacing:.01em}.istio-securityarch_svg__ec87a236-d3bd-47fa-a97d-d8c2e91f25a5{letter-spacing:-.01em}.istio-securityarch_svg__ea96df71-f7e5-489f-a491-48f7b5240008{fill:#231f20}.istio-securityarch_svg__f2687283-5cd6-4938-85c1-f20ed6449743{letter-spacing:-.01em}.istio-securityarch_svg__b9948846-df5c-4862-824f-c0b118fcfce3{letter-spacing:-.02em}.istio-securityarch_svg__a3f38e67-06e9-418e-964a-eba38bee4535{stroke:#777678}.istio-securityarch_svg__a398c1c0-1ae6-42aa-bd8e-928a7dc6a7af,.istio-securityarch_svg__e1911d25-aca7-4ebb-a506-9b48914bf416{isolation:isolate}.istio-securityarch_svg__ffc44ae6-5c1a-43f6-9d87-d14a453ac344{letter-spacing:0}.istio-securityarch_svg__b313f7eb-8a3a-46f4-89d4-f0df95a50ba8{letter-spacing:.01em}.istio-securityarch_svg__adbca6c4-a2ed-4117-a8ff-dbdf14aa73b3{letter-spacing:-.01em}.istio-securityarch_svg__b0090cf3-5ba2-4df5-8341-f9dff3d9c6b2{fill:#496caf}.istio-securityarch_svg__a398c1c0-1ae6-42aa-bd8e-928a7dc6a7af{font-size:8.96px}.istio-securityarch_svg__a23e4365-7061-4cf7-ae0d-85c3037da071,.istio-securityarch_svg__fb12fa33-92c3-487b-bcde-bb2b352fb0c9{letter-spacing:-.01em}.istio-securityarch_svg__bd469858-9647-42e7-81df-2abf2407061f{letter-spacing:.01em}.istio-securityarch_svg__a96b384f-7f9d-4ed0-a341-8b0f64612261{letter-spacing:0}.istio-securityarch_svg__ef2e4981-b11c-4582-b036-2228c6f6c08b{letter-spacing:-.01em}.istio-securityarch_svg__aadcb088-02c1-41ab-aec7-c8be292d41e0{letter-spacing:0}.istio-securityarch_svg__b7d0207d-1b80-4fdb-988b-02e06c583481{letter-spacing:-.02em}.istio-securityarch_svg__b3bee058-b072-4b79-97f9-0f2efd1191a9{letter-spacing:-.01em}.istio-securityarch_svg__b0076fcc-277d-4e12-804e-265328e3e3b1,.istio-securityarch_svg__bdd7232f-f6fd-4049-ad87-56c85dcf4369{letter-spacing:.01em}.istio-securityarch_svg__e51c0731-5533-4f31-8c99-2cd7e20066b9{letter-spacing:0}.istio-securityarch_svg__aeffcfd8-d86a-45a7-a3db-2d94146792a3{letter-spacing:-.02em}.istio-securityarch_svg__b557930e-ca76-42d9-95d2-6b4b210944e9{letter-spacing:0}.istio-securityarch_svg__f84c5900-a235-4989-ba10-4975976d5df3{letter-spacing:-.03em}.istio-securityarch_svg__a21c5b5f-aabe-488a-b849-04b288144b98{letter-spacing:.02em}.istio-securityarch_svg__a7d76100-fe89-4cf7-87e8-94d0926f4d27,.istio-securityarch_svg__e26d1663-69b3-454b-b962-dfbcbd173fb2{letter-spacing:-.02em}.istio-securityarch_svg__afce5dfd-bf76-4592-99c6-7ad79a19bbfe{letter-spacing:-.03em}.istio-securityarch_svg__b9c830ba-5174-4bc5-8188-f1ace757097b{fill:#009444}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 831.42,
    height: 154.17,
    x: 157.02,
    y: 315.33,
    className: "istio-securityarch_svg__b75fe515-d9ce-447c-aff3-ab473cb81ba9",
    rx: 9
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 897.6,
    height: 465.24,
    x: 118.9,
    y: 12.71,
    className: "istio-securityarch_svg__bd05d7e9-dff2-42d4-80e0-8544a2be094c",
    rx: 10
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "istio-securityarch_svg__afd526ee-25e6-459f-8c03-25ae8d4a7803",
    transform: "translate(118.9 10.3)"
  }, "I", /*#__PURE__*/React.createElement("tspan", {
    x: 3.52,
    y: 0,
    className: "istio-securityarch_svg__ab2bf7fd-baf8-4581-9478-25c8e49617f0"
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    x: 9.38,
    y: 0,
    className: "istio-securityarch_svg__a268483b-21e1-4920-849e-de9919c4d825"
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 14.36,
    y: 0,
    className: "istio-securityarch_svg__ab2bf7fd-baf8-4581-9478-25c8e49617f0"
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    x: 17.56,
    y: 0,
    className: "istio-securityarch_svg__b61332c7-925b-4261-8548-1c7de017d7fe"
  }, "o "), /*#__PURE__*/React.createElement("tspan", {
    x: 27.46,
    y: 0,
    className: "istio-securityarch_svg__ea92d7dd-0be3-4413-8853-ed38e711a5c4"
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    x: 38.08,
    y: 0,
    className: "istio-securityarch_svg__e3388f18-8853-483b-adb1-110dc806dcf3"
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 45,
    y: 0,
    className: "istio-securityarch_svg__b61332c7-925b-4261-8548-1c7de017d7fe"
  }, "sh"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.25 156.05a1.36 1.36 0 0 1 1 .4 1.34 1.34 0 0 1 .4 1V163a1.34 1.34 0 0 1-.4 1 1.36 1.36 0 0 1-1 .4H83a1.37 1.37 0 0 1-1.37-1.4v-5.58a1.37 1.37 0 0 1 1.37-1.37h.7V154a4.4 4.4 0 0 1 .59-2.21 4.54 4.54 0 0 1 1.62-1.61 4.42 4.42 0 0 1 4.41 0 4.54 4.54 0 0 1 1.68 1.56 4.4 4.4 0 0 1 .59 2.21v2.1Zm-3 0V154a2 2 0 0 0-.61-1.48 2.11 2.11 0 0 0-3 0A2 2 0 0 0 86 154v2.1Z",
    className: "istio-securityarch_svg__f1b48762-a0d4-422b-9317-38c92e67aea4"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "istio-securityarch_svg__a8cc6f2d-c1e4-4508-b7b0-186499b7717d",
    transform: "translate(66.31 132.53)"
  }, "JWT+", /*#__PURE__*/React.createElement("tspan", {
    x: 25.68,
    y: 0,
    className: "istio-securityarch_svg__b47a11b2-bdd4-4c94-a536-3ff3890aae6b"
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 27.6,
    y: 0
  }, "TLS"), /*#__PURE__*/React.createElement("tspan", {
    x: 9.63,
    y: 12,
    className: "istio-securityarch_svg__a6ab78ef-dc09-439b-b29c-a69373a26726"
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    x: 17.97,
    y: 12
  }, "TLS"))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1053.54 156.05a1.38 1.38 0 0 1 1.4 1.39V163a1.38 1.38 0 0 1-1.4 1.39h-10.22a1.38 1.38 0 0 1-1.4-1.39v-5.58a1.38 1.38 0 0 1 1.4-1.39h.69V154a4.3 4.3 0 0 1 .6-2.21 4.5 4.5 0 0 1 1.61-1.61 4.43 4.43 0 0 1 4.42 0 4.5 4.5 0 0 1 1.61 1.61 4.3 4.3 0 0 1 .6 2.21v2.1Zm-3 0V154a2.09 2.09 0 1 0-4.18 0v2.1Z",
    className: "istio-securityarch_svg__f1b48762-a0d4-422b-9317-38c92e67aea4"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "istio-securityarch_svg__a8cc6f2d-c1e4-4508-b7b0-186499b7717d",
    transform: "translate(1025.45 133.9)"
  }, "JWT +", /*#__PURE__*/React.createElement("tspan", {
    x: 28,
    y: 0,
    className: "istio-securityarch_svg__b47a11b2-bdd4-4c94-a536-3ff3890aae6b"
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 29.92,
    y: 0
  }, "TLS"), /*#__PURE__*/React.createElement("tspan", {
    x: 10.79,
    y: 12,
    className: "istio-securityarch_svg__a6ab78ef-dc09-439b-b29c-a69373a26726"
  }, "m"), /*#__PURE__*/React.createElement("tspan", {
    x: 19.13,
    y: 12
  }, "TLS"))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 205.85,
    height: 150.12,
    x: 281.86,
    y: 67.11,
    className: "istio-securityarch_svg__f911231f-cd5e-4ff1-9d21-8aa3b7be3411",
    rx: 3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 205.85,
    height: 150.12,
    x: 277.55,
    y: 62.8,
    className: "istio-securityarch_svg__b555c1bb-b960-46c7-8767-d80146dadbf4",
    rx: 3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 205.85,
    height: 150.12,
    x: 272.15,
    y: 57.4,
    className: "istio-securityarch_svg__f911231f-cd5e-4ff1-9d21-8aa3b7be3411",
    rx: 3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 117,
    height: 40.35,
    x: 316.58,
    y: 74.57,
    className: "istio-securityarch_svg__e9bb5c86-6a6c-4e63-a35a-a8db12e9f576",
    rx: 3
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "istio-securityarch_svg__f710b24f-5a6e-46e9-b971-052267f34d76",
    transform: "translate(368.4 99.26)"
  }, "Se", /*#__PURE__*/React.createElement("tspan", {
    x: 15.53,
    y: 0,
    className: "istio-securityarch_svg__f215488f-4682-4fb8-bf55-00eb7742a09b"
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 20.89,
    y: 0
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 27.92,
    y: 0,
    className: "istio-securityarch_svg__a444e6db-ea27-4308-8d0c-46755eb75974"
  }, "ic"), /*#__PURE__*/React.createElement("tspan", {
    x: 38.39,
    y: 0,
    className: "istio-securityarch_svg__aff424b6-2386-4897-a8aa-c88604ade126"
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 46.09,
    y: 0,
    className: "istio-securityarch_svg__a6ab78ef-dc09-439b-b29c-a69373a26726"
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 48.92,
    y: 0
  }, "A"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 343.03,
    cy: 94.74,
    r: 18,
    className: "istio-securityarch_svg__b555c1bb-b960-46c7-8767-d80146dadbf4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M336.64 88.23h12.79v12.79h-12.79z",
    className: "istio-securityarch_svg__b7126ed3-0723-4d7f-8489-44e9140a611e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M339.01 88.23v-3.08M343.03 88.23v-3.08M347.06 88.23v-3.08M339.01 104.33v-3.08M343.03 104.33v-3.08M347.06 104.33v-3.08M336.52 98.77h-3.08M336.52 94.74h-3.08M336.52 90.71h-3.08M352.63 98.77h-3.08M352.63 94.74h-3.08M352.63 90.71h-3.08",
    className: "istio-securityarch_svg__e490bdda-b499-42e6-a54a-e78f2b8aa3b2"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 5.68,
    height: 5.68,
    x: 340.19,
    y: 91.78,
    className: "istio-securityarch_svg__e9bb5c86-6a6c-4e63-a35a-a8db12e9f576",
    rx: 2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 117,
    height: 39.08,
    x: 316.58,
    y: 151.28,
    className: "istio-securityarch_svg__e9bb5c86-6a6c-4e63-a35a-a8db12e9f576",
    rx: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M356.84 178.47v-15.3l-13.26-7.65-13.26 7.65v15.3l13.26 7.65z",
    className: "istio-securityarch_svg__b08a60e8-d5e3-47c6-8765-54e91386a2e2"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "istio-securityarch_svg__f710b24f-5a6e-46e9-b971-052267f34d76",
    transform: "translate(369.01 175.26)"
  }, "P", /*#__PURE__*/React.createElement("tspan", {
    x: 8.04,
    y: 0,
    className: "istio-securityarch_svg__e0c131b3-1fb0-4364-99e1-d9ef61b24568"
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 12.74,
    y: 0,
    className: "istio-securityarch_svg__a2d57362-92c3-4fb5-ad27-66d8242cc870"
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    x: 20.61,
    y: 0
  }, "xy"))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m425.65 158.79 1 1a.48.48 0 0 1 .13.52.5.5 0 0 1-.38.37l-1.4.32.4 1.37a.51.51 0 0 1-.13.53.52.52 0 0 1-.54.14l-1.37-.4-.35 1.39a.48.48 0 0 1-.38.39.51.51 0 0 1-.51-.14l-1-1-1 1a.53.53 0 0 1-.52.14.46.46 0 0 1-.36-.39l-.36-1.39-1.37.4a.5.5 0 0 1-.53-.14.51.51 0 0 1-.14-.53l.4-1.37-1.39-.35a.51.51 0 0 1-.38-.37.49.49 0 0 1 .14-.52l1-1-1-1a.49.49 0 0 1-.14-.52.51.51 0 0 1 .38-.37l1.39-.35-.4-1.37a.51.51 0 0 1 .14-.53.5.5 0 0 1 .53-.14l1.37.4.36-1.39a.46.46 0 0 1 .37-.39.49.49 0 0 1 .51.14l1 1 1-1a.5.5 0 0 1 .52-.13.5.5 0 0 1 .37.38l.35 1.39 1.37-.4a.52.52 0 0 1 .54.14.51.51 0 0 1 .13.53l-.4 1.37 1.39.35a.5.5 0 0 1 .38.37.48.48 0 0 1-.13.52Z",
    className: "istio-securityarch_svg__aa256662-fce3-4dfa-8196-2ac4340fe192"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M423.66 182.28a.5.5 0 0 1 .15.37.52.52 0 0 1-.15.38l-3.72 3.72a.53.53 0 0 1-.38.16.5.5 0 0 1-.37-.16.5.5 0 0 1-.16-.38v-2.12h-3a.5.5 0 0 1-.38-.16.5.5 0 0 1-.15-.37v-2.13a.51.51 0 0 1 .53-.53h3v-2.13a.5.5 0 0 1 .16-.37.47.47 0 0 1 .37-.16.5.5 0 0 1 .38.16Zm1 4.45a2.12 2.12 0 0 0 2.13-2.13v-4.25a2.12 2.12 0 0 0-2.13-2.13h-1.86a.27.27 0 0 0-.27.27v.89a.25.25 0 0 0 .08.18.24.24 0 0 0 .19.08h1.86a.72.72 0 0 1 .71.71v4.25a.72.72 0 0 1-.71.71h-1.86a.27.27 0 0 0-.19.08.26.26 0 0 0-.08.19v.88a.26.26 0 0 0 .08.19.27.27 0 0 0 .19.08Z",
    className: "istio-securityarch_svg__f5b41e30-30ae-4f26-b089-04ac86fe57e2"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 203.41,
    height: 148.34,
    x: 678.32,
    y: 68.89,
    className: "istio-securityarch_svg__f911231f-cd5e-4ff1-9d21-8aa3b7be3411",
    rx: 3
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 203.41,
    height: 148.34,
    x: 674.05,
    y: 64.63,
    className: "istio-securityarch_svg__b555c1bb-b960-46c7-8767-d80146dadbf4",
    rx: 3
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 203.41,
    height: 148.34,
    x: 668.72,
    y: 59.3,
    className: "istio-securityarch_svg__f911231f-cd5e-4ff1-9d21-8aa3b7be3411",
    rx: 3
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 117,
    height: 40.35,
    x: 711.93,
    y: 74.57,
    className: "istio-securityarch_svg__e9bb5c86-6a6c-4e63-a35a-a8db12e9f576",
    rx: 3
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "istio-securityarch_svg__f710b24f-5a6e-46e9-b971-052267f34d76",
    transform: "translate(763.99 99.26)"
  }, "Se", /*#__PURE__*/React.createElement("tspan", {
    x: 15.53,
    y: 0,
    className: "istio-securityarch_svg__f215488f-4682-4fb8-bf55-00eb7742a09b"
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 20.89,
    y: 0
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 27.92,
    y: 0,
    className: "istio-securityarch_svg__a444e6db-ea27-4308-8d0c-46755eb75974"
  }, "ic"), /*#__PURE__*/React.createElement("tspan", {
    x: 38.39,
    y: 0,
    className: "istio-securityarch_svg__aff424b6-2386-4897-a8aa-c88604ade126"
  }, "e B"))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 738.38,
    cy: 94.74,
    r: 18,
    className: "istio-securityarch_svg__b555c1bb-b960-46c7-8767-d80146dadbf4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M731.99 88.23h12.79v12.79h-12.79z",
    className: "istio-securityarch_svg__b7126ed3-0723-4d7f-8489-44e9140a611e"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M734.36 88.23v-3.08M738.38 88.23v-3.08M742.41 88.23v-3.08M734.36 104.33v-3.08M738.38 104.33v-3.08M742.41 104.33v-3.08M731.87 98.77h-3.08M731.87 94.74h-3.08M731.87 90.71h-3.08M747.98 98.77h-3.08M747.98 94.74h-3.08M747.98 90.71h-3.08",
    className: "istio-securityarch_svg__e490bdda-b499-42e6-a54a-e78f2b8aa3b2"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 5.68,
    height: 5.68,
    x: 735.54,
    y: 91.78,
    className: "istio-securityarch_svg__e9bb5c86-6a6c-4e63-a35a-a8db12e9f576",
    rx: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M440.91 170.82h263.65",
    className: "istio-securityarch_svg__a6b88054-fdd2-41fb-8800-4aaaac89010e"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m442.37 175.81-8.64-4.99 8.64-4.99zM703.1 175.81l8.63-4.99-8.63-4.99z",
    className: "istio-securityarch_svg__b3dd7e29-de12-474a-868d-77c247e13299"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M374.62 121.94v22.65",
    className: "istio-securityarch_svg__a6b88054-fdd2-41fb-8800-4aaaac89010e"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m369.64 123.4 4.98-8.63 4.99 8.63zM369.64 143.13l4.98 8.64 4.99-8.64z",
    className: "istio-securityarch_svg__b3dd7e29-de12-474a-868d-77c247e13299"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M779.62 121.94v22.65",
    className: "istio-securityarch_svg__a6b88054-fdd2-41fb-8800-4aaaac89010e"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m774.64 123.4 4.98-8.63 4.99 8.63zM774.64 143.13l4.98 8.64 4.99-8.64z",
    className: "istio-securityarch_svg__b3dd7e29-de12-474a-868d-77c247e13299"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M297.64 158.77a1.38 1.38 0 0 1 1.39 1.4v5.58a1.36 1.36 0 0 1-.4 1 1.34 1.34 0 0 1-1 .4h-10.22a1.34 1.34 0 0 1-1-.4 1.36 1.36 0 0 1-.4-1v-5.58a1.38 1.38 0 0 1 1.39-1.4h.7v-2.09a4.4 4.4 0 0 1 .59-2.21 4.54 4.54 0 0 1 1.62-1.61 4.42 4.42 0 0 1 4.41 0 4.54 4.54 0 0 1 1.62 1.61 4.4 4.4 0 0 1 .59 2.21v2.09Zm-3 0v-2.09a2 2 0 0 0-.61-1.48 2.11 2.11 0 0 0-3 0 2 2 0 0 0-.61 1.48v2.09Z",
    className: "istio-securityarch_svg__f1b48762-a0d4-422b-9317-38c92e67aea4"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    className: "istio-securityarch_svg__bb4f2cbc-d575-4a0d-84f1-538b3757378c",
    transform: "translate(283.89 150.85)"
  }, "m", /*#__PURE__*/React.createElement("tspan", {
    x: 5.91,
    y: 0,
    className: "istio-securityarch_svg__fe02ae3a-15e1-46f2-8238-f497270e65c3"
  }, "TLS"))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M577.34 158.77a1.4 1.4 0 0 1 1.4 1.4v5.58a1.37 1.37 0 0 1-.41 1 1.34 1.34 0 0 1-1 .4h-10.22a1.34 1.34 0 0 1-1-.4 1.37 1.37 0 0 1-.41-1v-5.58a1.4 1.4 0 0 1 1.39-1.4h.7v-2.09a4.3 4.3 0 0 1 .6-2.21 4.44 4.44 0 0 1 1.61-1.61 4.43 4.43 0 0 1 4.42 0 4.6 4.6 0 0 1 1.61 1.61 4.3 4.3 0 0 1 .59 2.21v2.09Zm-3 0v-2.09a2.09 2.09 0 1 0-4.18 0v2.09Z",
    className: "istio-securityarch_svg__f1b48762-a0d4-422b-9317-38c92e67aea4"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    className: "istio-securityarch_svg__bb4f2cbc-d575-4a0d-84f1-538b3757378c",
    transform: "translate(563.6 150.85)"
  }, "m", /*#__PURE__*/React.createElement("tspan", {
    x: 5.91,
    y: 0,
    className: "istio-securityarch_svg__fe02ae3a-15e1-46f2-8238-f497270e65c3"
  }, "TLS"))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M861.64 158.77a1.4 1.4 0 0 1 1.4 1.4v5.58a1.37 1.37 0 0 1-.41 1 1.34 1.34 0 0 1-1 .4h-10.22a1.34 1.34 0 0 1-1-.4 1.37 1.37 0 0 1-.41-1v-5.58a1.4 1.4 0 0 1 1.39-1.4h.7v-2.09a4.3 4.3 0 0 1 .6-2.21 4.44 4.44 0 0 1 1.61-1.61 4.43 4.43 0 0 1 4.42 0 4.6 4.6 0 0 1 1.61 1.61 4.3 4.3 0 0 1 .6 2.21v2.09Zm-3 0v-2.09a2.09 2.09 0 1 0-4.18 0v2.09Z",
    className: "istio-securityarch_svg__f1b48762-a0d4-422b-9317-38c92e67aea4"
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    className: "istio-securityarch_svg__bb4f2cbc-d575-4a0d-84f1-538b3757378c",
    transform: "translate(847.9 150.85)"
  }, "m", /*#__PURE__*/React.createElement("tspan", {
    x: 5.91,
    y: 0,
    className: "istio-securityarch_svg__fe02ae3a-15e1-46f2-8238-f497270e65c3"
  }, "TLS"))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    className: "istio-securityarch_svg__a8abd049-976e-4fc1-ae51-c49f9aa3fee7",
    transform: "translate(516.8 259.71)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "istio-securityarch_svg__a810eeb5-5a15-4495-9be4-710ca0482784"
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 8.63,
    y: 0,
    className: "istio-securityarch_svg__e664c73c-edca-4ee3-8fe2-53e19520945e"
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    x: 15.43,
    y: 0,
    className: "istio-securityarch_svg__be90388b-953c-4ed6-ad3e-620ab818c306"
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    x: 21.78,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 26.08,
    y: 0,
    className: "istio-securityarch_svg__a6ab78ef-dc09-439b-b29c-a69373a26726"
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 30.11,
    y: 0,
    className: "istio-securityarch_svg__b74a8556-9fc9-4542-86da-8e2f8a352bc5"
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    x: 36.97,
    y: 0
  }, "l "), /*#__PURE__*/React.createElement("tspan", {
    x: 42.26,
    y: 0,
    className: "istio-securityarch_svg__f294b4bc-f111-4b0c-b273-d813f8cd51c6"
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    x: 49.21,
    y: 0,
    className: "istio-securityarch_svg__b74a8556-9fc9-4542-86da-8e2f8a352bc5"
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    x: 51.66,
    y: 0
  }, "ane I"), /*#__PURE__*/React.createElement("tspan", {
    x: 76.88,
    y: 0,
    className: "istio-securityarch_svg__b9f4022a-cb44-4b28-9d49-2e44f3559bf8"
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    x: 83.23,
    y: 0,
    className: "istio-securityarch_svg__a11a0377-9de2-4d2e-8295-e64eabcec3bc"
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 87.26,
    y: 0,
    className: "istio-securityarch_svg__e6480a8b-4b7e-4e1a-a2e5-f1e99d17a805"
  }, "er"), /*#__PURE__*/React.createElement("tspan", {
    x: 98.25,
    y: 0,
    className: "istio-securityarch_svg__a810eeb5-5a15-4495-9be4-710ca0482784"
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    x: 102.46,
    y: 0,
    className: "istio-securityarch_svg__b74a8556-9fc9-4542-86da-8e2f8a352bc5"
  }, "ac"), /*#__PURE__*/React.createElement("tspan", {
    x: 115.01,
    y: 0
  }, "e"))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    className: "istio-securityarch_svg__a8abd049-976e-4fc1-ae51-c49f9aa3fee7",
    transform: "translate(527.94 185.78)"
  }, "HTT", /*#__PURE__*/React.createElement("tspan", {
    x: 21.28,
    y: 0,
    className: "istio-securityarch_svg__e3ffed98-503d-45b3-b0c6-b7874c340aa6"
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    x: 27.2,
    y: 0
  }, ", gR"), /*#__PURE__*/React.createElement("tspan", {
    x: 46.93,
    y: 0,
    className: "istio-securityarch_svg__e664c73c-edca-4ee3-8fe2-53e19520945e"
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    x: 53.7,
    y: 0
  }, "C,"), /*#__PURE__*/React.createElement("tspan", {
    x: 65.44,
    y: 0,
    className: "istio-securityarch_svg__b7667c73-2320-4c1d-85d4-96bd11145e54"
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 67.74,
    y: 0,
    className: "istio-securityarch_svg__b5415851-a9cf-4cd0-9014-873c46460b72"
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 73.84,
    y: 0,
    className: "istio-securityarch_svg__af6d43bc-00a4-4711-a1cb-95cd49d9a76c"
  }, "CP"))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    className: "istio-securityarch_svg__a8abd049-976e-4fc1-ae51-c49f9aa3fee7",
    transform: "translate(157.02 129.51)"
  }, "D", /*#__PURE__*/React.createElement("tspan", {
    x: 8.42,
    y: 0,
    className: "istio-securityarch_svg__e664c73c-edca-4ee3-8fe2-53e19520945e"
  }, "at"), /*#__PURE__*/React.createElement("tspan", {
    x: 18.74,
    y: 0
  }, "a "), /*#__PURE__*/React.createElement("tspan", {
    x: 27.79,
    y: 0,
    className: "istio-securityarch_svg__e664c73c-edca-4ee3-8fe2-53e19520945e"
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    x: 34.7,
    y: 0,
    className: "istio-securityarch_svg__a4a8bb30-a42b-42b3-a70f-d7d928142f4a"
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    x: 37.15,
    y: 0,
    className: "istio-securityarch_svg__e6480a8b-4b7e-4e1a-a2e5-f1e99d17a805"
  }, "ane"))), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    className: "istio-securityarch_svg__a8abd049-976e-4fc1-ae51-c49f9aa3fee7",
    transform: "translate(157.02 312.03)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "istio-securityarch_svg__a810eeb5-5a15-4495-9be4-710ca0482784"
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 8.63,
    y: 0,
    className: "istio-securityarch_svg__e664c73c-edca-4ee3-8fe2-53e19520945e"
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    x: 15.43,
    y: 0,
    className: "istio-securityarch_svg__be90388b-953c-4ed6-ad3e-620ab818c306"
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    x: 21.78,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 26.08,
    y: 0,
    className: "istio-securityarch_svg__a6ab78ef-dc09-439b-b29c-a69373a26726"
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 30.11,
    y: 0,
    className: "istio-securityarch_svg__b74a8556-9fc9-4542-86da-8e2f8a352bc5"
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    x: 36.97,
    y: 0
  }, "l "), /*#__PURE__*/React.createElement("tspan", {
    x: 42.26,
    y: 0,
    className: "istio-securityarch_svg__e664c73c-edca-4ee3-8fe2-53e19520945e"
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    x: 49.18,
    y: 0,
    className: "istio-securityarch_svg__b74a8556-9fc9-4542-86da-8e2f8a352bc5"
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    x: 51.62,
    y: 0
  }, "ane"))), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 74.82,
    height: 74.82,
    x: 172.7,
    y: 145.16,
    className: "istio-securityarch_svg__f911231f-cd5e-4ff1-9d21-8aa3b7be3411",
    rx: 3
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 62.35,
    height: 18.71,
    x: 178.94,
    y: 195.04,
    className: "istio-securityarch_svg__e9bb5c86-6a6c-4e63-a35a-a8db12e9f576",
    rx: 3
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    className: "istio-securityarch_svg__a8cc6f2d-c1e4-4508-b7b0-186499b7717d",
    transform: "translate(194.24 207.74)"
  }, "I", /*#__PURE__*/React.createElement("tspan", {
    x: 2.44,
    y: 0,
    className: "istio-securityarch_svg__f77554e1-c234-40bf-abe0-204ca99438d5"
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    x: 7.93,
    y: 0
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    x: 13.81,
    y: 0,
    className: "istio-securityarch_svg__b2116ce1-e6d1-4eee-9fa6-6cb9d29b3ff3"
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 17.17,
    y: 0,
    className: "istio-securityarch_svg__bcf7907a-0a3a-46f6-b6ba-66a19443026c"
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 22.72,
    y: 0
  }, "ss"))), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 37.41,
    height: 37.41,
    x: 191.41,
    y: 151.39,
    className: "istio-securityarch_svg__e9bb5c86-6a6c-4e63-a35a-a8db12e9f576",
    rx: 3
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M219.3 175.4v-10.61l-9.19-5.29-9.18 5.29v10.61l9.18 5.29z",
    className: "istio-securityarch_svg__b08a60e8-d5e3-47c6-8765-54e91386a2e2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "istio-securityarch_svg__a0e05cc7-0916-46e0-a018-b6b738d0280b",
    d: "M175.92 145.16h14.16v14.16h-14.16z",
    className: "istio-securityarch_svg__fb5ff91e-8f6c-4919-a823-bd6b85396607",
    "data-name": "background"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "istio-securityarch_svg__ea80aee1-49df-4e6b-8570-2bf297adba5e",
    d: "M178.76 157.02h8.49l-5.31 1.59z",
    className: "istio-securityarch_svg__e9bb5c86-6a6c-4e63-a35a-a8db12e9f576",
    "data-name": "hull"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "istio-securityarch_svg__b6a2e997-8459-4604-85e0-42b96b5b288b",
    d: "m178.76 156.49 3.18-.53v-5.85z",
    className: "istio-securityarch_svg__e9bb5c86-6a6c-4e63-a35a-a8db12e9f576",
    "data-name": "mainsail"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "istio-securityarch_svg__ff992d56-5f87-4ae3-87cb-cca734d98945",
    d: "m182.47 155.96 4.78.53-4.78-10.63z",
    className: "istio-securityarch_svg__e9bb5c86-6a6c-4e63-a35a-a8db12e9f576",
    "data-name": "headsail"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m242.91 158.79 1 1a.48.48 0 0 1 .13.52.5.5 0 0 1-.37.37l-1.4.35.4 1.37a.51.51 0 0 1-.13.53.5.5 0 0 1-.53.14l-1.38-.4-.35 1.39a.48.48 0 0 1-.38.39.51.51 0 0 1-.51-.14l-1-1-1 1a.53.53 0 0 1-.52.14.46.46 0 0 1-.36-.39l-.36-1.39-1.37.4a.5.5 0 0 1-.53-.14.49.49 0 0 1-.13-.53l.39-1.37-1.39-.35a.51.51 0 0 1-.38-.37.49.49 0 0 1 .14-.52l1-1-1-1a.49.49 0 0 1-.14-.52.51.51 0 0 1 .38-.37l1.39-.35-.39-1.37a.49.49 0 0 1 .13-.53.5.5 0 0 1 .53-.14l1.37.4.36-1.39a.47.47 0 0 1 .37-.39.49.49 0 0 1 .51.14l1 1 1-1a.5.5 0 0 1 .52-.13.5.5 0 0 1 .37.38l.35 1.39 1.38-.4a.5.5 0 0 1 .53.14.51.51 0 0 1 .13.53l-.4 1.37 1.4.35a.5.5 0 0 1 .37.37.48.48 0 0 1-.13.52Z",
    className: "istio-securityarch_svg__aa256662-fce3-4dfa-8196-2ac4340fe192"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 74.82,
    height: 74.82,
    x: 897.99,
    y: 145.16,
    className: "istio-securityarch_svg__f911231f-cd5e-4ff1-9d21-8aa3b7be3411",
    rx: 3
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 62.35,
    height: 18.71,
    x: 904.22,
    y: 195.04,
    className: "istio-securityarch_svg__e9bb5c86-6a6c-4e63-a35a-a8db12e9f576",
    rx: 3
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    className: "istio-securityarch_svg__a8cc6f2d-c1e4-4508-b7b0-186499b7717d",
    transform: "translate(920.8 207.74)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "istio-securityarch_svg__f1c88488-b5ef-4a20-b5d1-08319cc6fd65"
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    x: 5.4,
    y: 0
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    x: 11.28,
    y: 0,
    className: "istio-securityarch_svg__eda56b98-ff2a-4819-971e-c6ea8d36d0f7"
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 14.64,
    y: 0,
    className: "istio-securityarch_svg__bcf7907a-0a3a-46f6-b6ba-66a19443026c"
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 20.19,
    y: 0
  }, "ss"))), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 37.41,
    height: 37.41,
    x: 916.69,
    y: 151.39,
    className: "istio-securityarch_svg__e9bb5c86-6a6c-4e63-a35a-a8db12e9f576",
    rx: 3
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M944.58 175.4v-10.61l-9.18-5.29-9.19 5.29v10.61l9.19 5.29z",
    className: "istio-securityarch_svg__b08a60e8-d5e3-47c6-8765-54e91386a2e2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "istio-securityarch_svg__b703de0d-1c47-44ea-81c9-2a5a05deeae6",
    d: "M901.21 145.16h14.16v14.16h-14.16z",
    className: "istio-securityarch_svg__fb5ff91e-8f6c-4919-a823-bd6b85396607",
    "data-name": "background"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "istio-securityarch_svg__eed55057-88e5-4a3a-940d-16cb984b28e5",
    d: "M904.04 157.02h8.5l-5.31 1.59z",
    className: "istio-securityarch_svg__e9bb5c86-6a6c-4e63-a35a-a8db12e9f576",
    "data-name": "hull"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "istio-securityarch_svg__b1ab0523-1288-4f8f-bab9-328f51aa91d2",
    d: "m904.04 156.49 3.19-.53v-5.85z",
    className: "istio-securityarch_svg__e9bb5c86-6a6c-4e63-a35a-a8db12e9f576",
    "data-name": "mainsail"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "istio-securityarch_svg__fbf77926-903e-400e-bd5d-2119a45d0abb",
    d: "m907.76 155.96 4.78.53-4.78-10.63z",
    className: "istio-securityarch_svg__e9bb5c86-6a6c-4e63-a35a-a8db12e9f576",
    "data-name": "headsail"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m969.33 158.79 1 1a.48.48 0 0 1 .13.52.5.5 0 0 1-.37.37l-1.4.35.4 1.37a.51.51 0 0 1-.13.53.5.5 0 0 1-.53.14l-1.38-.4-.35 1.39a.47.47 0 0 1-.38.39.51.51 0 0 1-.51-.14l-1-1-1 1a.53.53 0 0 1-.52.14.46.46 0 0 1-.36-.39l-.36-1.39-1.37.4a.5.5 0 0 1-.53-.14.49.49 0 0 1-.13-.53l.46-1.4-1.4-.35a.53.53 0 0 1-.24-.89l1-1-1-1a.53.53 0 0 1 .24-.89l1.4-.35-.4-1.37a.49.49 0 0 1 .13-.53.5.5 0 0 1 .53-.14l1.37.4.36-1.39a.47.47 0 0 1 .37-.39.49.49 0 0 1 .51.14l1 1 1-1a.51.51 0 0 1 .52-.13.48.48 0 0 1 .37.38l.35 1.39 1.38-.4a.5.5 0 0 1 .53.14.51.51 0 0 1 .13.53l-.4 1.37 1.4.35a.5.5 0 0 1 .37.37.48.48 0 0 1-.13.52Z",
    className: "istio-securityarch_svg__aa256662-fce3-4dfa-8196-2ac4340fe192"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9 170.4h134.42",
    className: "istio-securityarch_svg__a6b88054-fdd2-41fb-8800-4aaaac89010e"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m183.86 175.39 8.64-4.99-8.64-4.98z",
    className: "istio-securityarch_svg__b3dd7e29-de12-474a-868d-77c247e13299"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M228.82 170.82h80.58",
    className: "istio-securityarch_svg__a6b88054-fdd2-41fb-8800-4aaaac89010e"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "m307.94 175.81 8.64-4.99-8.64-4.99z",
    className: "istio-securityarch_svg__b3dd7e29-de12-474a-868d-77c247e13299"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M828.62 170.4h80.9",
    className: "istio-securityarch_svg__a6b88054-fdd2-41fb-8800-4aaaac89010e"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m908.06 175.39 8.63-4.99-8.63-4.98z",
    className: "istio-securityarch_svg__b3dd7e29-de12-474a-868d-77c247e13299"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M954.1 170.4h123.21",
    className: "istio-securityarch_svg__a6b88054-fdd2-41fb-8800-4aaaac89010e"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "m1075.85 175.39 8.64-4.99-8.64-4.98z",
    className: "istio-securityarch_svg__b3dd7e29-de12-474a-868d-77c247e13299"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 117,
    height: 39.08,
    x: 712.38,
    y: 151.28,
    className: "istio-securityarch_svg__e9bb5c86-6a6c-4e63-a35a-a8db12e9f576",
    rx: 3
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M818.12 178.47v-15.3l-13.26-7.65-13.26 7.65v15.3l13.26 7.65z",
    className: "istio-securityarch_svg__b08a60e8-d5e3-47c6-8765-54e91386a2e2"
  })), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    className: "istio-securityarch_svg__f710b24f-5a6e-46e9-b971-052267f34d76",
    transform: "translate(744.54 175.26)"
  }, "P", /*#__PURE__*/React.createElement("tspan", {
    x: 8.04,
    y: 0,
    className: "istio-securityarch_svg__e0c131b3-1fb0-4364-99e1-d9ef61b24568"
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 12.74,
    y: 0,
    className: "istio-securityarch_svg__a2d57362-92c3-4fb5-ad27-66d8242cc870"
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    x: 20.61,
    y: 0
  }, "xy"))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "m730.62 158.79 1 1a.49.49 0 0 1 .14.52.51.51 0 0 1-.38.37L730 161l.39 1.37a.49.49 0 0 1-.13.53.5.5 0 0 1-.53.14l-1.37-.4-.36 1.39a.47.47 0 0 1-.37.39.49.49 0 0 1-.51-.14l-1-1-1 1a.53.53 0 0 1-.52.14.48.48 0 0 1-.37-.39l-.35-1.39-1.38.4a.5.5 0 0 1-.53-.14.51.51 0 0 1-.13-.53l.4-1.37-1.4-.35a.5.5 0 0 1-.37-.37.48.48 0 0 1 .13-.52l1-1-1-1a.48.48 0 0 1-.13-.52.5.5 0 0 1 .37-.37l1.4-.35-.4-1.37a.51.51 0 0 1 .13-.53.5.5 0 0 1 .53-.14l1.38.4.35-1.39a.48.48 0 0 1 .38-.39.51.51 0 0 1 .51.14l1 1 1-1a.5.5 0 0 1 .52-.13.47.47 0 0 1 .36.38l.36 1.39 1.37-.4a.5.5 0 0 1 .53.14.49.49 0 0 1 .13.53l-.39 1.37 1.39.35a.51.51 0 0 1 .38.37.49.49 0 0 1-.14.52Z",
    className: "istio-securityarch_svg__aa256662-fce3-4dfa-8196-2ac4340fe192"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M728.62 182.28a.5.5 0 0 1 .16.37.5.5 0 0 1-.16.38l-3.72 3.72a.5.5 0 0 1-.37.16.53.53 0 0 1-.38-.16.52.52 0 0 1-.15-.38v-2.12h-3a.55.55 0 0 1-.53-.53v-2.13a.5.5 0 0 1 .16-.38.5.5 0 0 1 .37-.15h3v-2.13a.5.5 0 0 1 .15-.37.5.5 0 0 1 .38-.16.47.47 0 0 1 .37.16Zm1 4.45a2 2 0 0 0 1.5-.62 2.07 2.07 0 0 0 .62-1.51v-4.25a2.08 2.08 0 0 0-.62-1.51 2 2 0 0 0-1.5-.62h-1.86a.26.26 0 0 0-.19.08.27.27 0 0 0-.08.19v.89a.25.25 0 0 0 .08.18.22.22 0 0 0 .19.08h1.86a.67.67 0 0 1 .49.21.7.7 0 0 1 .21.5v4.25a.7.7 0 0 1-.21.5.67.67 0 0 1-.49.21h-1.86a.27.27 0 0 0-.27.27v.88a.27.27 0 0 0 .27.27Z",
    className: "istio-securityarch_svg__f5b41e30-30ae-4f26-b089-04ac86fe57e2"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M577.61 326.96v-60.57H343.58v-69.34",
    className: "istio-securityarch_svg__fbf59e5c-7545-4d21-8f09-14871b9280fe"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "m348.57 198.51-4.99-8.64-4.99 8.64z",
    className: "istio-securityarch_svg__fb5ff91e-8f6c-4919-a823-bd6b85396607"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M343.58 266.39H228.82v-39.73",
    className: "istio-securityarch_svg__fbf59e5c-7545-4d21-8f09-14871b9280fe"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "m233.8 228.12-4.98-8.63-4.99 8.63z",
    className: "istio-securityarch_svg__fb5ff91e-8f6c-4919-a823-bd6b85396607"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M577.61 266.39h227.25v-69.34",
    className: "istio-securityarch_svg__fbf59e5c-7545-4d21-8f09-14871b9280fe"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "m809.85 198.51-4.99-8.64-4.99 8.64z",
    className: "istio-securityarch_svg__fb5ff91e-8f6c-4919-a823-bd6b85396607"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M804.86 266.39h110.51v-39.73",
    className: "istio-securityarch_svg__fbf59e5c-7545-4d21-8f09-14871b9280fe"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "m920.36 228.12-4.99-8.63-4.98 8.63z",
    className: "istio-securityarch_svg__fb5ff91e-8f6c-4919-a823-bd6b85396607"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "m624.42 527.7 1.53 1.5a.75.75 0 0 1 .2.78.74.74 0 0 1-.57.55l-2.09.53.6 2.06a.75.75 0 0 1-.2.79.76.76 0 0 1-.8.2l-2.06-.6-.53 2.1a.7.7 0 0 1-.56.58.75.75 0 0 1-.77-.22l-1.49-1.53-1.49 1.56a.8.8 0 0 1-.78.22.7.7 0 0 1-.55-.58l-.53-2.1-2.06.6a.76.76 0 0 1-.8-.2.75.75 0 0 1-.2-.79l.6-2.06-2.09-.53a.74.74 0 0 1-.57-.55.74.74 0 0 1 .2-.78l1.53-1.5-1.53-1.49a.74.74 0 0 1-.2-.78.74.74 0 0 1 .57-.55l2.09-.53-.6-2.06a.8.8 0 0 1 1-1l2.06.59.53-2.09a.7.7 0 0 1 .56-.58.73.73 0 0 1 .77.22l1.49 1.56 1.49-1.56a.74.74 0 0 1 .78-.2.72.72 0 0 1 .55.56l.53 2.09 2.06-.59a.8.8 0 0 1 1 1l-.6 2.06 2.09.53a.74.74 0 0 1 .57.55.75.75 0 0 1-.2.78Z",
    className: "istio-securityarch_svg__aa256662-fce3-4dfa-8196-2ac4340fe192"
  })), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    className: "istio-securityarch_svg__a8abd049-976e-4fc1-ae51-c49f9aa3fee7",
    transform: "translate(589.25 512.72)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "istio-securityarch_svg__a810eeb5-5a15-4495-9be4-710ca0482784"
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 8.63,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 15.23,
    y: 0,
    className: "istio-securityarch_svg__e63f4eeb-de41-4515-91a9-a2e2c10abae1"
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 19.74,
    y: 0,
    className: "istio-securityarch_svg__e3388f18-8853-483b-adb1-110dc806dcf3"
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 24.1,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    x: 26.78,
    y: 0,
    className: "istio-securityarch_svg__ec87a236-d3bd-47fa-a97d-d8c2e91f25a5"
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    x: 31.1,
    y: 0,
    className: "istio-securityarch_svg__b74a8556-9fc9-4542-86da-8e2f8a352bc5"
  }, "ic"), /*#__PURE__*/React.createElement("tspan", {
    x: 40.08,
    y: 0,
    className: "istio-securityarch_svg__e664c73c-edca-4ee3-8fe2-53e19520945e"
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 46.22,
    y: 0,
    className: "istio-securityarch_svg__a11a0377-9de2-4d2e-8295-e64eabcec3bc"
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 50.26,
    y: 0
  }, "e"))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M530.8 527.27a.75.75 0 0 1 .23.57.73.73 0 0 1-.23.56l-5.58 5.6a.73.73 0 0 1-.56.23.75.75 0 0 1-.57-.23.77.77 0 0 1-.23-.56v-3.19h-4.52a.77.77 0 0 1-.56-.23.78.78 0 0 1-.24-.57v-3.19a.82.82 0 0 1 .8-.8h4.52v-3.18a.79.79 0 0 1 .8-.8.77.77 0 0 1 .56.23Zm1.56 6.68a3.18 3.18 0 0 0 3.19-3.19v-6.38a3.18 3.18 0 0 0-3.19-3.19h-2.79a.41.41 0 0 0-.4.4v1.33a.36.36 0 0 0 .12.28.38.38 0 0 0 .28.12h2.79a1 1 0 0 1 .75.31 1 1 0 0 1 .32.75v6.38a1.08 1.08 0 0 1-1.07 1.06h-2.79a.41.41 0 0 0-.4.4v1.33a.36.36 0 0 0 .12.28.38.38 0 0 0 .28.12Z",
    className: "istio-securityarch_svg__f5b41e30-30ae-4f26-b089-04ac86fe57e2"
  })), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    className: "istio-securityarch_svg__ea96df71-f7e5-489f-a491-48f7b5240008",
    transform: "translate(513.06 498.32)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "istio-securityarch_svg__f2687283-5cd6-4938-85c1-f20ed6449743"
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    x: 5.94,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    x: 12.86,
    y: 0,
    className: "istio-securityarch_svg__ab2bf7fd-baf8-4581-9478-25c8e49617f0"
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 19.21,
    y: 0
  }, "al"), /*#__PURE__*/React.createElement("tspan", {
    x: -21,
    y: 14.4
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: -14.74,
    y: 14.4,
    className: "istio-securityarch_svg__a268483b-21e1-4920-849e-de9919c4d825"
  }, "ut"), /*#__PURE__*/React.createElement("tspan", {
    x: -3.67,
    y: 14.4
  }, "h"), /*#__PURE__*/React.createElement("tspan", {
    x: 2.99,
    y: 14.4,
    className: "istio-securityarch_svg__e664c73c-edca-4ee3-8fe2-53e19520945e"
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    x: 9.79,
    y: 14.4
  }, "ri"), /*#__PURE__*/React.createElement("tspan", {
    x: 16.87,
    y: 14.4,
    className: "istio-securityarch_svg__ea92d7dd-0be3-4413-8853-ed38e711a5c4"
  }, "za"), /*#__PURE__*/React.createElement("tspan", {
    x: 28.55,
    y: 14.4,
    className: "istio-securityarch_svg__a268483b-21e1-4920-849e-de9919c4d825"
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 32.9,
    y: 14.4,
    className: "istio-securityarch_svg__ab2bf7fd-baf8-4581-9478-25c8e49617f0"
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    x: 35.53,
    y: 14.4,
    className: "istio-securityarch_svg__ea92d7dd-0be3-4413-8853-ed38e711a5c4"
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    x: 42.34,
    y: 14.4
  }, "n"))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M384.49 521.46h80.35",
    className: "istio-securityarch_svg__fbf59e5c-7545-4d21-8f09-14871b9280fe"
  })), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    className: "istio-securityarch_svg__a8abd049-976e-4fc1-ae51-c49f9aa3fee7",
    transform: "translate(389.1 498.32)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "istio-securityarch_svg__a810eeb5-5a15-4495-9be4-710ca0482784"
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 8.63,
    y: 0,
    className: "istio-securityarch_svg__e664c73c-edca-4ee3-8fe2-53e19520945e"
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    x: 15.43,
    y: 0,
    className: "istio-securityarch_svg__be90388b-953c-4ed6-ad3e-620ab818c306"
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    x: 21.78,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 26.08,
    y: 0,
    className: "istio-securityarch_svg__a6ab78ef-dc09-439b-b29c-a69373a26726"
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 30.11,
    y: 0,
    className: "istio-securityarch_svg__b74a8556-9fc9-4542-86da-8e2f8a352bc5"
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    x: 36.97,
    y: 0
  }, "l "), /*#__PURE__*/React.createElement("tspan", {
    x: 42.26,
    y: 0,
    className: "istio-securityarch_svg__e664c73c-edca-4ee3-8fe2-53e19520945e"
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    x: 49.18,
    y: 0,
    className: "istio-securityarch_svg__b74a8556-9fc9-4542-86da-8e2f8a352bc5"
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    x: 51.62,
    y: 0
  }, "ane"), /*#__PURE__*/React.createElement("tspan", {
    x: 19.49,
    y: 14.4
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 23.79,
    y: 14.4,
    className: "istio-securityarch_svg__b9948846-df5c-4862-824f-c0b118fcfce3"
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 27.94,
    y: 14.4,
    className: "istio-securityarch_svg__e664c73c-edca-4ee3-8fe2-53e19520945e"
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 34.08,
    y: 14.4,
    className: "istio-securityarch_svg__a810eeb5-5a15-4495-9be4-710ca0482784"
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    x: 38.29,
    y: 14.4,
    className: "istio-securityarch_svg__ec87a236-d3bd-47fa-a97d-d8c2e91f25a5"
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    x: 42.61,
    y: 14.4,
    className: "istio-securityarch_svg__b74a8556-9fc9-4542-86da-8e2f8a352bc5"
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    x: 45.23,
    y: 14.4
  }, "c"))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M276.93 521.46h80.35",
    className: "istio-securityarch_svg__a6b88054-fdd2-41fb-8800-4aaaac89010e"
  })), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    className: "istio-securityarch_svg__a8abd049-976e-4fc1-ae51-c49f9aa3fee7",
    transform: "translate(288.77 498.32)"
  }, "D", /*#__PURE__*/React.createElement("tspan", {
    x: 8.42,
    y: 0,
    className: "istio-securityarch_svg__e664c73c-edca-4ee3-8fe2-53e19520945e"
  }, "at"), /*#__PURE__*/React.createElement("tspan", {
    x: 18.74,
    y: 0
  }, "a "), /*#__PURE__*/React.createElement("tspan", {
    x: 27.79,
    y: 0,
    className: "istio-securityarch_svg__e664c73c-edca-4ee3-8fe2-53e19520945e"
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    x: 34.7,
    y: 0,
    className: "istio-securityarch_svg__a4a8bb30-a42b-42b3-a70f-d7d928142f4a"
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    x: 37.15,
    y: 0,
    className: "istio-securityarch_svg__e6480a8b-4b7e-4e1a-a2e5-f1e99d17a805"
  }, "ane"), /*#__PURE__*/React.createElement("tspan", {
    x: 12.26,
    y: 14.4
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 16.55,
    y: 14.4,
    className: "istio-securityarch_svg__b9948846-df5c-4862-824f-c0b118fcfce3"
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 20.71,
    y: 14.4,
    className: "istio-securityarch_svg__e664c73c-edca-4ee3-8fe2-53e19520945e"
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 26.85,
    y: 14.4,
    className: "istio-securityarch_svg__a810eeb5-5a15-4495-9be4-710ca0482784"
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    x: 31.05,
    y: 14.4,
    className: "istio-securityarch_svg__ec87a236-d3bd-47fa-a97d-d8c2e91f25a5"
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    x: 35.37,
    y: 14.4,
    className: "istio-securityarch_svg__b74a8556-9fc9-4542-86da-8e2f8a352bc5"
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    x: 38,
    y: 14.4
  }, "c"))), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    className: "istio-securityarch_svg__a8abd049-976e-4fc1-ae51-c49f9aa3fee7",
    transform: "translate(227.12 498.32)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "istio-securityarch_svg__a810eeb5-5a15-4495-9be4-710ca0482784"
  }, "K"), /*#__PURE__*/React.createElement("tspan", {
    x: 7.25,
    y: 0,
    className: "istio-securityarch_svg__e664c73c-edca-4ee3-8fe2-53e19520945e"
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 13.73,
    y: 0
  }, "y:"))), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 378.75,
    height: 116.71,
    x: 391.67,
    y: 326.96,
    className: "istio-securityarch_svg__a3f38e67-06e9-418e-964a-eba38bee4535",
    rx: 3
  })), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    className: "istio-securityarch_svg__e1911d25-aca7-4ebb-a506-9b48914bf416",
    transform: "translate(438.6 364.45)"
  }, "i", /*#__PURE__*/React.createElement("tspan", {
    x: 3.14,
    y: 0,
    className: "istio-securityarch_svg__ffc44ae6-5c1a-43f6-9d87-d14a453ac344"
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    x: 9.55,
    y: 0,
    className: "istio-securityarch_svg__b313f7eb-8a3a-46f4-89d4-f0df95a50ba8"
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 14.63,
    y: 0,
    className: "istio-securityarch_svg__adbca6c4-a2ed-4117-a8ff-dbdf14aa73b3"
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    x: 17.7,
    y: 0
  }, "od"))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "istio-securityarch_svg__a5ad7299-9961-42be-85d1-8819ccafd567",
    d: "M406.55 346.43h27.55v27.55h-27.55z",
    className: "istio-securityarch_svg__b0090cf3-5ba2-4df5-8341-f9dff3d9c6b2",
    "data-name": "background"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "istio-securityarch_svg__beebd2d1-6be1-4d1a-a79d-8d76f7bccadf",
    d: "M413.37 367.69h13.91l-8.66 2.62z",
    className: "istio-securityarch_svg__e9bb5c86-6a6c-4e63-a35a-a8db12e9f576",
    "data-name": "hull"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "istio-securityarch_svg__a8b991de-d31c-462d-af5a-7f9bfc94ef8c",
    d: "m413.37 366.9 5.25-.78v-9.45z",
    className: "istio-securityarch_svg__e9bb5c86-6a6c-4e63-a35a-a8db12e9f576",
    "data-name": "mainsail"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "istio-securityarch_svg__f2d96f20-dc14-427b-bcc1-0e023ce8b0db",
    d: "m419.41 366.12 7.87.78-7.87-17.05z",
    className: "istio-securityarch_svg__e9bb5c86-6a6c-4e63-a35a-a8db12e9f576",
    "data-name": "headsail"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M567.81 412.81h-74.6a3 3 0 0 1-3-3v-22.4a3.08 3.08 0 0 1 3-3h74.6a3.08 3.08 0 0 1 3 3v22.4a3 3 0 0 1-3 3",
    className: "istio-securityarch_svg__e9bb5c86-6a6c-4e63-a35a-a8db12e9f576"
  })), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    className: "istio-securityarch_svg__a398c1c0-1ae6-42aa-bd8e-928a7dc6a7af",
    transform: "translate(513.55 395.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "istio-securityarch_svg__a23e4365-7061-4cf7-ae0d-85c3037da071"
  }, "N"), /*#__PURE__*/React.createElement("tspan", {
    x: 6.25,
    y: 0,
    className: "istio-securityarch_svg__fb12fa33-92c3-487b-bcde-bb2b352fb0c9"
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 11.04,
    y: 0,
    className: "istio-securityarch_svg__bd469858-9647-42e7-81df-2abf2407061f"
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 14.38,
    y: 0,
    className: "istio-securityarch_svg__a23e4365-7061-4cf7-ae0d-85c3037da071"
  }, "wo"), /*#__PURE__*/React.createElement("tspan", {
    x: 26.17,
    y: 0,
    className: "istio-securityarch_svg__a96b384f-7f9d-4ed0-a341-8b0f64612261"
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.5,
    y: 0
  }, "k"), /*#__PURE__*/React.createElement("tspan", {
    x: -9.55,
    y: 10.75,
    className: "istio-securityarch_svg__ef2e4981-b11c-4582-b036-2228c6f6c08b"
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: -4.81,
    y: 10.75,
    className: "istio-securityarch_svg__a23e4365-7061-4cf7-ae0d-85c3037da071"
  }, "onf"), /*#__PURE__*/React.createElement("tspan", {
    x: 8.37,
    y: 10.75,
    className: "istio-securityarch_svg__aadcb088-02c1-41ab-aec7-c8be292d41e0"
  }, "ig"), /*#__PURE__*/React.createElement("tspan", {
    x: 15.56,
    y: 10.75
  }, "u"), /*#__PURE__*/React.createElement("tspan", {
    x: 20.52,
    y: 10.75,
    className: "istio-securityarch_svg__b7d0207d-1b80-4fdb-988b-02e06c583481"
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 23.62,
    y: 10.75,
    className: "istio-securityarch_svg__b3bee058-b072-4b79-97f9-0f2efd1191a9"
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 28.21,
    y: 10.75,
    className: "istio-securityarch_svg__bdd7232f-f6fd-4049-ad87-56c85dcf4369"
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 31.46,
    y: 10.75,
    className: "istio-securityarch_svg__aadcb088-02c1-41ab-aec7-c8be292d41e0"
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    x: 33.42,
    y: 10.75,
    className: "istio-securityarch_svg__b3bee058-b072-4b79-97f9-0f2efd1191a9"
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    x: 38.5,
    y: 10.75
  }, "n"))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M567.81 374.41h-74.6a3 3 0 0 1-3-3V349a3.08 3.08 0 0 1 3-3h74.6a3.08 3.08 0 0 1 3 3v22.4a3 3 0 0 1-3 3.01",
    className: "istio-securityarch_svg__e9bb5c86-6a6c-4e63-a35a-a8db12e9f576"
  })), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    className: "istio-securityarch_svg__a398c1c0-1ae6-42aa-bd8e-928a7dc6a7af",
    transform: "translate(509.29 357.55)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "istio-securityarch_svg__b7d0207d-1b80-4fdb-988b-02e06c583481"
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: 6.44,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 11.37,
    y: 0,
    className: "istio-securityarch_svg__b0076fcc-277d-4e12-804e-265328e3e3b1"
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 14.74,
    y: 0,
    className: "istio-securityarch_svg__a96b384f-7f9d-4ed0-a341-8b0f64612261"
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 17.99,
    y: 0,
    className: "istio-securityarch_svg__e51c0731-5533-4f31-8c99-2cd7e20066b9"
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    x: 20,
    y: 0,
    className: "istio-securityarch_svg__a23e4365-7061-4cf7-ae0d-85c3037da071"
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    x: 23.22,
    y: 0,
    className: "istio-securityarch_svg__aadcb088-02c1-41ab-aec7-c8be292d41e0"
  }, "ic"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.93,
    y: 0,
    className: "istio-securityarch_svg__b3bee058-b072-4b79-97f9-0f2efd1191a9"
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 34.51,
    y: 0,
    className: "istio-securityarch_svg__aeffcfd8-d86a-45a7-a3db-2d94146792a3"
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 37.52,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 3.23,
    y: 10.75
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 7.91,
    y: 10.75,
    className: "istio-securityarch_svg__a96b384f-7f9d-4ed0-a341-8b0f64612261"
  }, "ut"), /*#__PURE__*/React.createElement("tspan", {
    x: 16.17,
    y: 10.75
  }, "h"), /*#__PURE__*/React.createElement("tspan", {
    x: 21.14,
    y: 10.75,
    className: "istio-securityarch_svg__a23e4365-7061-4cf7-ae0d-85c3037da071"
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    x: 26.22,
    y: 10.75
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.5,
    y: 10.75,
    className: "istio-securityarch_svg__aadcb088-02c1-41ab-aec7-c8be292d41e0"
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    x: 31.46,
    y: 10.75,
    className: "istio-securityarch_svg__bdd7232f-f6fd-4049-ad87-56c85dcf4369"
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 34.72,
    y: 10.75,
    className: "istio-securityarch_svg__b557930e-ca76-42d9-95d2-6b4b210944e9"
  }, "y"))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M662 374.41h-74.6a3 3 0 0 1-3-3V349a3.08 3.08 0 0 1 3-3H662a3.08 3.08 0 0 1 3 3v22.4a3 3 0 0 1-3 3.01",
    className: "istio-securityarch_svg__e9bb5c86-6a6c-4e63-a35a-a8db12e9f576"
  })), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    className: "istio-securityarch_svg__a398c1c0-1ae6-42aa-bd8e-928a7dc6a7af",
    transform: "translate(595.47 357.55)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "istio-securityarch_svg__f84c5900-a235-4989-ba10-4975976d5df3"
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 5.76,
    y: 0,
    className: "istio-securityarch_svg__a96b384f-7f9d-4ed0-a341-8b0f64612261"
  }, "ut"), /*#__PURE__*/React.createElement("tspan", {
    x: 14.02,
    y: 0
  }, "he"), /*#__PURE__*/React.createElement("tspan", {
    x: 23.92,
    y: 0,
    className: "istio-securityarch_svg__f84c5900-a235-4989-ba10-4975976d5df3"
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    x: 28.66,
    y: 0,
    className: "istio-securityarch_svg__a96b384f-7f9d-4ed0-a341-8b0f64612261"
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 31.91,
    y: 0,
    className: "istio-securityarch_svg__aadcb088-02c1-41ab-aec7-c8be292d41e0"
  }, "ic"), /*#__PURE__*/React.createElement("tspan", {
    x: 38.62,
    y: 0,
    className: "istio-securityarch_svg__b3bee058-b072-4b79-97f9-0f2efd1191a9"
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 43.2,
    y: 0,
    className: "istio-securityarch_svg__bdd7232f-f6fd-4049-ad87-56c85dcf4369"
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 46.46,
    y: 0,
    className: "istio-securityarch_svg__aadcb088-02c1-41ab-aec7-c8be292d41e0"
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    x: 48.42,
    y: 0,
    className: "istio-securityarch_svg__b3bee058-b072-4b79-97f9-0f2efd1191a9"
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    x: 53.5,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    x: 14.19,
    y: 10.75
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    x: 19.44,
    y: 10.75,
    className: "istio-securityarch_svg__ef2e4981-b11c-4582-b036-2228c6f6c08b"
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    x: 24.57,
    y: 10.75,
    className: "istio-securityarch_svg__e51c0731-5533-4f31-8c99-2cd7e20066b9"
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    x: 26.44,
    y: 10.75,
    className: "istio-securityarch_svg__ef2e4981-b11c-4582-b036-2228c6f6c08b"
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    x: 28.4,
    y: 10.75
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 33.19,
    y: 10.75,
    className: "istio-securityarch_svg__aadcb088-02c1-41ab-aec7-c8be292d41e0"
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    x: 35.15,
    y: 10.75,
    className: "istio-securityarch_svg__bdd7232f-f6fd-4049-ad87-56c85dcf4369"
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 40.12,
    y: 10.75
  }, "s"))), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M662 412.81h-74.6a3 3 0 0 1-3-3v-22.4a3.08 3.08 0 0 1 3-3H662a3.08 3.08 0 0 1 3 3v22.4a3 3 0 0 1-3 3",
    className: "istio-securityarch_svg__e9bb5c86-6a6c-4e63-a35a-a8db12e9f576"
  })), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    className: "istio-securityarch_svg__a398c1c0-1ae6-42aa-bd8e-928a7dc6a7af",
    transform: "translate(598.03 395.94)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "istio-securityarch_svg__f84c5900-a235-4989-ba10-4975976d5df3"
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 5.76,
    y: 0,
    className: "istio-securityarch_svg__a96b384f-7f9d-4ed0-a341-8b0f64612261"
  }, "ut"), /*#__PURE__*/React.createElement("tspan", {
    x: 14.02,
    y: 0
  }, "h"), /*#__PURE__*/React.createElement("tspan", {
    x: 18.99,
    y: 0,
    className: "istio-securityarch_svg__a23e4365-7061-4cf7-ae0d-85c3037da071"
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    x: 24.08,
    y: 0
  }, "ri"), /*#__PURE__*/React.createElement("tspan", {
    x: 29.36,
    y: 0,
    className: "istio-securityarch_svg__a23e4365-7061-4cf7-ae0d-85c3037da071"
  }, "za"), /*#__PURE__*/React.createElement("tspan", {
    x: 38.08,
    y: 0,
    className: "istio-securityarch_svg__a96b384f-7f9d-4ed0-a341-8b0f64612261"
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 41.33,
    y: 0,
    className: "istio-securityarch_svg__aadcb088-02c1-41ab-aec7-c8be292d41e0"
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    x: 43.29,
    y: 0,
    className: "istio-securityarch_svg__a23e4365-7061-4cf7-ae0d-85c3037da071"
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    x: 48.37,
    y: 0,
    className: "istio-securityarch_svg__b557930e-ca76-42d9-95d2-6b4b210944e9"
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    x: 11.63,
    y: 10.75
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    x: 16.88,
    y: 10.75,
    className: "istio-securityarch_svg__ef2e4981-b11c-4582-b036-2228c6f6c08b"
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    x: 22,
    y: 10.75,
    className: "istio-securityarch_svg__e51c0731-5533-4f31-8c99-2cd7e20066b9"
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    x: 23.88,
    y: 10.75,
    className: "istio-securityarch_svg__ef2e4981-b11c-4582-b036-2228c6f6c08b"
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    x: 25.84,
    y: 10.75
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 30.62,
    y: 10.75,
    className: "istio-securityarch_svg__aadcb088-02c1-41ab-aec7-c8be292d41e0"
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    x: 32.59,
    y: 10.75,
    className: "istio-securityarch_svg__bdd7232f-f6fd-4049-ad87-56c85dcf4369"
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 37.56,
    y: 10.75
  }, "s"))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M614.91 457.87h-74.6a3 3 0 0 1-3-3v-22.4a3.08 3.08 0 0 1 3-3h74.6a3.08 3.08 0 0 1 3 3v22.4a3 3 0 0 1-3 3",
    className: "istio-securityarch_svg__e9bb5c86-6a6c-4e63-a35a-a8db12e9f576"
  })), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    className: "istio-securityarch_svg__a398c1c0-1ae6-42aa-bd8e-928a7dc6a7af",
    transform: "translate(557.35 441.01)"
  }, "API ", /*#__PURE__*/React.createElement("tspan", {
    x: 15.39,
    y: 0,
    className: "istio-securityarch_svg__a96b384f-7f9d-4ed0-a341-8b0f64612261"
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    x: 19.59,
    y: 0,
    className: "istio-securityarch_svg__e51c0731-5533-4f31-8c99-2cd7e20066b9"
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 24.51,
    y: 0,
    className: "istio-securityarch_svg__a21c5b5f-aabe-488a-b849-04b288144b98"
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 27.95,
    y: 0,
    className: "istio-securityarch_svg__a7d76100-fe89-4cf7-87e8-94d0926f4d27"
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 32.31,
    y: 0,
    className: "istio-securityarch_svg__e51c0731-5533-4f31-8c99-2cd7e20066b9"
  }, "er"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.25,
    y: 10.75,
    className: "istio-securityarch_svg__ef2e4981-b11c-4582-b036-2228c6f6c08b"
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: -1.51,
    y: 10.75,
    className: "istio-securityarch_svg__a23e4365-7061-4cf7-ae0d-85c3037da071"
  }, "onf"), /*#__PURE__*/React.createElement("tspan", {
    x: 11.67,
    y: 10.75,
    className: "istio-securityarch_svg__aadcb088-02c1-41ab-aec7-c8be292d41e0"
  }, "ig"), /*#__PURE__*/React.createElement("tspan", {
    x: 18.86,
    y: 10.75
  }, "u"), /*#__PURE__*/React.createElement("tspan", {
    x: 23.82,
    y: 10.75,
    className: "istio-securityarch_svg__b7d0207d-1b80-4fdb-988b-02e06c583481"
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 26.92,
    y: 10.75,
    className: "istio-securityarch_svg__b3bee058-b072-4b79-97f9-0f2efd1191a9"
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 31.51,
    y: 10.75,
    className: "istio-securityarch_svg__bdd7232f-f6fd-4049-ad87-56c85dcf4369"
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 34.76,
    y: 10.75,
    className: "istio-securityarch_svg__aadcb088-02c1-41ab-aec7-c8be292d41e0"
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    x: 36.72,
    y: 10.75,
    className: "istio-securityarch_svg__b3bee058-b072-4b79-97f9-0f2efd1191a9"
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    x: 41.8,
    y: 10.75
  }, "n"))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4 155.81a8.26 8.26 0 0 1 4.23 1.19 8.43 8.43 0 0 1 4.24 7.34v2.65a3 3 0 0 1-3 3H20.56a3 3 0 0 1-3-3v-2.65a8.3 8.3 0 0 1 1.14-4.24 8.4 8.4 0 0 1 3.1-3.1 8.27 8.27 0 0 1 4.2-1.19h1.07a11.07 11.07 0 0 0 9.24 0Zm-5.7-2a8.1 8.1 0 1 1 4.08-15.12 7.83 7.83 0 0 1 2.94 2.94 8.27 8.27 0 0 1 0 8.17 7.83 7.83 0 0 1-2.94 2.94 8 8 0 0 1-4.08 1.04Z",
    className: "istio-securityarch_svg__b555c1bb-b960-46c7-8767-d80146dadbf4"
  })), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    className: "istio-securityarch_svg__ea96df71-f7e5-489f-a491-48f7b5240008",
    transform: "translate(20.01 185.78)"
  }, "APIs", /*#__PURE__*/React.createElement("tspan", {
    x: -9.83,
    y: 14.4,
    className: "istio-securityarch_svg__a810eeb5-5a15-4495-9be4-710ca0482784"
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    x: -1.21,
    y: 14.4,
    className: "istio-securityarch_svg__ea92d7dd-0be3-4413-8853-ed38e711a5c4"
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    x: 5.6,
    y: 14.4,
    className: "istio-securityarch_svg__b9f4022a-cb44-4b28-9d49-2e44f3559bf8"
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    x: 11.95,
    y: 14.4,
    className: "istio-securityarch_svg__e26d1663-69b3-454b-b962-dfbcbd173fb2"
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 15.98,
    y: 14.4
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 22.58,
    y: 14.4,
    className: "istio-securityarch_svg__afce5dfd-bf76-4592-99c6-7ad79a19bbfe"
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    x: 28.93,
    y: 14.4
  }, "t"))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M1112.2 155.81a8.27 8.27 0 0 1 4.24 1.14 8.4 8.4 0 0 1 3.1 3.1 8.3 8.3 0 0 1 1.14 4.24v2.65a3 3 0 0 1-3 3h-22.28a3 3 0 0 1-3-3v-2.65a8.43 8.43 0 0 1 4.24-7.34 8.26 8.26 0 0 1 4.23-1.14h1.08a11.07 11.07 0 0 0 9.24 0Zm-5.69-2a8 8 0 0 1-4.08-1.07 7.83 7.83 0 0 1-2.94-2.94 8.27 8.27 0 0 1 0-8.17 7.83 7.83 0 0 1 2.94-2.94 8.12 8.12 0 1 1 4.08 15.12",
    className: "istio-securityarch_svg__b555c1bb-b960-46c7-8767-d80146dadbf4"
  })), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    className: "istio-securityarch_svg__ea96df71-f7e5-489f-a491-48f7b5240008",
    transform: "translate(1085.22 185.78)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "istio-securityarch_svg__ea92d7dd-0be3-4413-8853-ed38e711a5c4"
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    x: 6.48,
    y: 0
  }, "x"), /*#__PURE__*/React.createElement("tspan", {
    x: 12.19,
    y: 0,
    className: "istio-securityarch_svg__e26d1663-69b3-454b-b962-dfbcbd173fb2"
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 16.22,
    y: 0,
    className: "istio-securityarch_svg__b61332c7-925b-4261-8548-1c7de017d7fe"
  }, "er"), /*#__PURE__*/React.createElement("tspan", {
    x: 27.22,
    y: 0,
    className: "istio-securityarch_svg__ab2bf7fd-baf8-4581-9478-25c8e49617f0"
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    x: 33.8,
    y: 0
  }, "al"), /*#__PURE__*/React.createElement("tspan", {
    x: 12.37,
    y: 14.4
  }, "API"))), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M240.92 182.28a.52.52 0 0 1 .16.37.53.53 0 0 1-.16.38l-3.72 3.72a.53.53 0 0 1-.38.16.52.52 0 0 1-.37-.16.5.5 0 0 1-.16-.38v-2.12h-3a.5.5 0 0 1-.38-.16.5.5 0 0 1-.15-.37v-2.13a.51.51 0 0 1 .53-.53h3v-2.13a.55.55 0 0 1 .53-.53.5.5 0 0 1 .38.16Zm1 4.45a2.12 2.12 0 0 0 2.13-2.13v-4.25a2.12 2.12 0 0 0-2.13-2.13h-1.82a.27.27 0 0 0-.19.08.26.26 0 0 0-.07.19v.89a.24.24 0 0 0 .07.18.24.24 0 0 0 .19.08h1.9a.72.72 0 0 1 .71.71v4.25a.72.72 0 0 1-.71.71h-1.9a.27.27 0 0 0-.19.08.25.25 0 0 0-.07.19v.88a.25.25 0 0 0 .07.19.27.27 0 0 0 .19.08ZM967.34 182.28a.52.52 0 0 1 .16.37.53.53 0 0 1-.16.38l-3.72 3.72a.53.53 0 0 1-.38.16.52.52 0 0 1-.37-.16.5.5 0 0 1-.16-.38v-2.12h-3a.5.5 0 0 1-.38-.16.5.5 0 0 1-.15-.37v-2.13a.51.51 0 0 1 .53-.53h3v-2.13a.55.55 0 0 1 .53-.53.5.5 0 0 1 .38.16Zm1 4.45a2.12 2.12 0 0 0 2.13-2.13v-4.25a2.12 2.12 0 0 0-2.13-2.13h-1.86a.3.3 0 0 0-.19.08.26.26 0 0 0-.07.19v.89a.24.24 0 0 0 .07.18.25.25 0 0 0 .19.08h1.86a.72.72 0 0 1 .71.71v4.25a.72.72 0 0 1-.71.71h-1.86a.3.3 0 0 0-.19.08.25.25 0 0 0-.07.19v.88a.25.25 0 0 0 .07.19.3.3 0 0 0 .19.08Z",
    className: "istio-securityarch_svg__f5b41e30-30ae-4f26-b089-04ac86fe57e2"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 831.42,
    height: 95.67,
    x: 157.02,
    y: 132.46,
    className: "istio-securityarch_svg__b9c830ba-5174-4bc5-8188-f1ace757097b",
    rx: 9
  })));
};
export { SvgIstioSecurityarch as ReactComponent };
export default __webpack_public_path__ + "static/istio-securityarch.48cc1d41.svg";